import { SpyneTrait } from 'spyne';
import { StageContainer } from 'components/stage-container.js';
import { DeckControlsView } from 'components/ui-elements/deck-controls-view.js';
import { LocalStorageNullView } from 'components/ui-elements/null-views/local-storage-null-view.js';
import { FullscreenNullView } from 'components/ui-elements/null-views/fullscreen-null-view.js';

export class AppContainerTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'app$';
    super(context, traitPrefix);
  }

  static app$SetTheme(theme = 'dark', props = this.props) {
    props.el.dataset.theme = theme;
  }

  static app$OnLocalStorageEvent(e) {
    const { theme } = e.payload;
    this.app$SetTheme(theme);
  }

  // CSS reads main#app[data-fullscreen]: the control icon swap.
  static app$OnFullscreenChange(e, props = this.props) {
    props.el.dataset.fullscreen = String(e.payload?.isFullscreen === true);
  }

  // One-page deck: stage and bottom-right controls. The header, nav, menu
  // drawer, breadcrumb and footer are no longer mounted.
  static app$OnAppViewRendered() {
    this.appendView(new StageContainer());
    this.appendView(new DeckControlsView());
    new LocalStorageNullView().appendToNull();
    new FullscreenNullView().appendToNull();
  }
}
